import React, { useEffect, Fragment } from 'react';
import { useParams } from 'react-router-dom';
import {useVerifyUserMutation} from "../services/accountsApi";

import ErrorMessage from "../components/errorMessage";
import Login from "../screens/login";

const Verify = ({ show, handleClose, handleShow }) => {

  const [initVerifyUser, {isLoading: verifyUserIsLoading}] = useVerifyUserMutation();

  let { token } = useParams();
  useEffect(() => {
    initVerifyUser({
      token: token,
    }).unwrap()
      .then(r => console.log(r))
      .catch(error => console.log(error));
  }, [token]);
  return (
    <Fragment>
      <Login handleClose={handleClose} show={show} />
      <div className="verify-screen">
        <ErrorMessage button={true} buttonText="Sign In" onClick={handleShow} message="Your email address has been verified" />
      </div>
    </Fragment>
  );
}
export default Verify;